import React from "react";
import ErrorField from "./error";
import { TextField } from "components/support";
import { observer } from "mobx-react";

const NcmField = ({ errors, row, onChange }) => {
  const { taxes } = row;
  const foundErrors = errors.find(v => v.name === row.name);
  const hasErrors =
    foundErrors &&
    !!foundErrors.errors &&
    !!foundErrors.errors.taxes &&
    !!foundErrors.errors.taxes.ncm;

  return (
    <div>
      <TextField
        value={taxes.ncm}
        onChange={(_, value) => onChange(value.replace(/\D/g, ""))}
        fullWidth
      />
      {hasErrors && <ErrorField error={foundErrors.errors.taxes.ncm} />}
    </div>
  );
};

export default observer(NcmField);



// WEBPACK FOOTER //
// ./src/components/app/registration/product/batch/fields/ncm.js